"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewPendingCustomerSalesOrderLink = void 0;
const React = require("react");
const react_router_dom_1 = require("react-router-dom");
const retailOrderingRoutes_1 = require("../../../../../../apps/spg/ordering/components/RetailOrderingApp/retailOrderingRoutes");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ViewPendingCustomerSalesOrderLink");
const ViewPendingCustomerSalesOrderLink = ({ salesOrderId }) => {
    const history = (0, react_router_dom_1.useHistory)();
    const navigateToOutstandingSalesOrder = (salesOrderId) => history.push((0, retailOrderingRoutes_1.toSalesOrderSummary)(salesOrderId), history.location.pathname);
    return (React.createElement("div", { className: css("") },
        React.createElement("div", { className: css("link"), onClick: () => navigateToOutstandingSalesOrder(salesOrderId) }, "view")));
};
exports.ViewPendingCustomerSalesOrderLink = ViewPendingCustomerSalesOrderLink;
//# sourceMappingURL=index.js.map